/**
 * Navigation Availability Filter Web Component
 * Minimal approach - only adds CSS classes to hide unavailable items
 */
class NavAvailabilityFilter extends HTMLElement {
  constructor() {
    super();
    this.cache = new Map();
  }

  connectedCallback() {
    this.init();
  }

  async init() {
    // Only target specific menu items with data attributes
    const items = this.querySelectorAll('[data-nav-availability]');
    
    for (const item of items) {
      await this.checkItem(item);
    }
  }

  async checkItem(item) {
    const handle = item.dataset.navAvailability;
    if (!handle) return;

    try {
      const available = await this.checkAvailability(handle);
      
      if (available) {
        item.classList.remove('nav-unavailable');
        item.classList.add('nav-available');
      } else {
        item.classList.add('nav-unavailable');
        item.classList.remove('nav-available');
      }
    } catch (error) {
      // Fail open - show item
      item.classList.add('nav-available');
      item.classList.remove('nav-unavailable');
    }
  }

  async checkAvailability(handle) {
    if (this.cache.has(handle)) {
      return this.cache.get(handle);
    }

    try {
      const response = await fetch(`/collections/${handle}?view=availability-check`);
      const data = await response.json();
      const available = data.has_sellable_products || false;
      
      this.cache.set(handle, available);
      return available;
    } catch (error) {
      return true; // Fail open
    }
  }
}

// Register the web component
if (!customElements.get('nav-availability-filter')) {
  customElements.define('nav-availability-filter', NavAvailabilityFilter);
}
